import { all, call } from 'redux-saga/effects';

import { sagas as unblockipSagas } from './unblockipModule';

export default function* sagas() {
	yield all([call(unblockipSagas)]);
}
